<!-- 活动列表 -->

<template>
  <div class="main" v-loading="loading">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-select v-model="project" placeholder="选择项目应用" @change="onSearch" clearable class="s_input">
        <el-option v-for="item in projectOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-input class="s_input" v-model="activityCode" placeholder="搜索活动编号" suffix-icon="el-icon-search"
        @change="onSearch" clearable></el-input>
      <el-input class="s_input" v-model="activityName" placeholder="搜索活动名称" suffix-icon="el-icon-search"
        @change="onSearch" clearable></el-input>
      <el-cascader :options="cascaderOptions" placeholder="选择活动分类" v-model="categoryIds" @change="onSearch"
        :props="cascaderprops" collapse-tags clearable></el-cascader>
      <el-select class="s_input" v-model="status" placeholder="选择活动状态" clearable @change="onSearch">
        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button class="btn" type="primary" @click="handleCheck(1)">新增活动</el-button>
      <el-button class="btn" type="primary" :disabled="this.multipleSelection.length == 0"
        @click="batchChangeStatus('up')">批量上架</el-button>
      <el-button class="btn" type="primary" plain :disabled="this.multipleSelection.length == 0"
        @click="batchChangeStatus('down')">批量下架</el-button>
    </div>
    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" fixed="left"></el-table-column>
        <el-table-column label="序号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="项目应用">
          <template slot-scope="scope">
            <span v-if="scope.row.project == 1">养长福</span>
            <span v-if="scope.row.project == 2">脑健康</span>
          </template>
        </el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <span class="show_img" @click="previewImage(scope.row.picUrl)">查看图片</span>
          </template>
        </el-table-column>
        <el-table-column min-width="150" show-overflow-tooltip prop="activityCode" label="活动编号"></el-table-column>
        <el-table-column min-width="150" show-overflow-tooltip prop="activityName" label="活动名称"></el-table-column>
        <el-table-column min-width="160" show-overflow-tooltip prop="categoryName" label="活动分类"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip prop="" label="最大报名数"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip prop="" label="已报名人数"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip prop="" label="活动价格(元)"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="" label="活动发布时间"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="" label="报名截止时间"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="" label="活动开始时间"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="" label="活动结束时间"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="活动状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">报名中</span>
            <span v-if="scope.row.status == 2">待开始</span>
            <span v-if="scope.row.status == 3">进行中</span>
            <span v-if="scope.row.status == 4">已结束</span>
          </template>
        </el-table-column>
        <el-table-column label="活动状态" header-align="center" align="center" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.switch" active-color="#1777D9" inactive-color="#E2E2E2"
              @change="changeStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="250"
          min-width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" @click="handleView(scope.row)">报名明细</el-button>
            <el-button type="primary" plain @click="handleCheck(scope.row)">修改</el-button>
            <el-button type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-image-viewer v-if="showViewer" :on-close="() => {
      showViewer = false
    }
      " :url-list="imgList"></el-image-viewer>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      loading: false,
      project: "", // 选择项目应用
      projectOptions: [{
        value: "1",
        label: "养长福",
      },
      {
        value: "2",
        label: "脑健康",
      },
      ],
      activityCode: "", // 搜索活动编号
      activityName: "", // 搜索活动名称
      categoryIds: "", // 选择分类
      cascaderOptions: [],
      cascaderprops: {
        checkStrictly: false,
        emitPath: false,
        multiple: true,
        value: "categoryId",
        label: "categoryName",
        children: "children",
      },
      status: "", // 活动状态
      statusOptions: [{
        label: "下架",
        value: "2",
      },
      {
        label: "上架",
        value: "1",
      },
      ],
      multipleSelection: [],
      // 表格数据
      tableData: [{ id: 1 }],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）

      showViewer: false,
      imgList: [],
    }
  },
  created() {
    // this.selectPositionInfoList()
    // this.getCategoryList()
  },
  methods: {
    // 获取列表
    selectPositionInfoList() {
      this.loading = true
      this.$axios
        .post(this.$api.selectPositionInfoList, {
          categoryIdList: this.categoryIds.length == 0 ? null : this.categoryIds,
          positionName: this.positionName || null,
          areaType: this.area || null,
          status: this.status || null,
          type: 1,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list.map(e => {
              return {
                ...e,
                switch: e.status == 1 ? true : false,
              }
            }) || []
            this.totalItemsCount = res.result.totalCount
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    getCategoryList() {
      this.$axios
        .get(this.$api.getCategoryList, {
          params: {
            page: 1,
            pageSize: 9999,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.cascaderOptions = res.result.list
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 批量切换上下架状态
    batchChangeStatus(status) {
      const action = status === "up" ? "上架" : "下架"
      const ids = this.multipleSelection.map(item => item.positionId)
      this.$confirm(`确定批量${action}这些活动吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then((res) => {
          this.$axios
            .post(this.$api.updateStatus, {
              positionIdList: ids,
              status: status == "up" ? 1 : 2,
            })
            .then((res) => {
              this.multipleSelection.forEach(item => {
                item.switch = status == "up" ? true : false
              })
              // this.$message.success(`批量${action}操作成功`)
              this.$message.success(res.desc)
              this.selectPositionInfoList()
            })
            .catch((err) => {
              // this.$message.error(`批量${action}操作失败`)
              this.$message.error(err.desc)
              this.selectPositionInfoList()
            })
        })
        .catch(() => {
          // 取消操作时恢复之前的选择状态
          this.multipleSelection.forEach(item => {
            item.switch = !item.switch
          })
          this.selectPositionInfoList()
        })
    },
    // 切换上下架
    changeStatus(row) {
      const originalSwitch = row.switch
      this.$confirm(`确定${row.switch ? "上架" : "下架"}该活动吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.updateStatus, {
              positionIdList: [row.positionId],
              status: row.switch ? 1 : 2,
            })
            .then((res) => {
              this.$set(row, "switch", originalSwitch)
              this.$message.success(res.desc)
              this.selectPositionInfoList()
            })
            .catch((err) => {
              this.$set(row, "switch", !originalSwitch)
              this.$message.error(err.desc)
              this.selectPositionInfoList()
            })
        })
        .catch(() => {
          this.$set(row, "switch", !originalSwitch)
          this.selectPositionInfoList()
        })
    },
    // 编辑
    handleCheck(row) {
      if (row == 1) {
        this.$router.push("/activity/list/apply")
      } else {
        this.$router.push({
          path: "/activity/list/apply",
          query: {
            // positionId: row.positionId,
            id: 1,
          },
        })
      }
    },
    handleView(row) {
      console.log(row);

      // 报名明细
      this.$router.push("/activity/list/applyList")
    },
    // 删除
    handleDelete(row) {
      this.$confirm("是否要删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .get(this.$api.deletePositionInfo, {
              params: {
                positionId: row.positionId
              }
            })
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.selectPositionInfoList()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message("取消删除")
        })
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.selectPositionInfoList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData()
      this.pageSize = e
      this.selectPositionInfoList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectPositionInfoList()
    },
    // 图片预览
    previewImage(url) {
      this.imgList = [url] || []
      this.showViewer = true
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  .show_img {
    color: $themes;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
